var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.componentType,{tag:"component",staticClass:"question-input-area",attrs:{"question":_vm.question,"inputText":_vm.inputText,"inputNumericalFormula":_vm.inputNumericalFormula,"inputJapanese":_vm.inputJapanese,"inputEnglish":_vm.inputEnglish,"inputSingleChoice":_vm.inputSingleChoice}})
}
var staticRenderFns = []

export { render, staticRenderFns }